import $ from 'jquery';
import Swiper, {Lazy, Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination, Lazy]);

export default function ProductListGallery() {
}

ProductListGallery.prototype.republish = function (slider) {
  this.removeSwipes();
  $(".productlist-gallery-swiper-container").each(function () {
    var $swiperEl = $(this);
    var $parentEl = $swiperEl.parent();
    var $paginationEl = $parentEl.find('.productlist-gallery-swiper-element.carousel-indicators');
    var $navNextEl = $parentEl.find('.productlist-gallery-swiper-element.swiper-button-next');
    var $navPrevEl = $parentEl.find('.productlist-gallery-swiper-element.swiper-button-prev');

    new Swiper($swiperEl.get(), {
      watchOverflow: true,
      speed: 600,
      preloadImages: false,
      watchSlidesVisibility: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      pagination: {
        el: $paginationEl.get(),
        clickable: true,
        bulletClass: "carousel-indicators-bullet",
        bulletActiveClass: "active",
        renderBullet: function (index, className) {
          return '<li class="' + className + '"><span></span></li>';
        }
      },
      navigation: {
        nextEl: $navNextEl.get(),
        prevEl: $navPrevEl.get()
      }
    });
  });
};

ProductListGallery.prototype.removeSwipes = function () {
  $(".gallery-productlist-swipe.swipe").each(function () {
    if ($(this).params) {
      $(this).destroy(true, true);
    }
  });
};

ProductListGallery.prototype.responsive = function (msg, on_off) {
  switch (msg) {
    case 'res.xs':
      if (on_off) { // entered state xs
        this.removeSwipes();
        $(".productlist-gallery-swiper-container").each(function () {
          var $swiperEl = $(this);
          var $parentEl = $swiperEl.parent();
          var $paginationEl = $parentEl.find('.productlist-gallery-swiper-element.carousel-indicators');
          var $navNextEl = $parentEl.find('.productlist-gallery-swiper-element.swiper-button-next');
          var $navPrevEl = $parentEl.find('.productlist-gallery-swiper-element.swiper-button-prev');

          new Swiper($swiperEl.get(), {
            watchOverflow: true,
            speed: 600,
            preloadImages: false,
            watchSlidesVisibility: true,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            pagination: {
              el: $paginationEl.get(),
              clickable: true,
              bulletClass: "carousel-indicators-bullet",
              bulletActiveClass: "active",
              renderBullet: function (index, className) {
                return '<li class="' + className + '"><span></span></li>';
              }
            },
            navigation: {
              nextEl: $navNextEl.get(),
              prevEl: $navPrevEl.get()
            }
          });
        });
      }
      break;
    case 'res.sm':
      if (on_off) { // entered state sm
        this.removeSwipes();
        $(".productlist-gallery-swiper-container").each(function () {
          var $swiperEl = $(this);
          var $parentEl = $swiperEl.parent();
          var $paginationEl = $parentEl.find('.productlist-gallery-swiper-element.carousel-indicators');

          new Swiper($swiperEl.get(), {
            watchOverflow: true,
            speed: 600,
            preloadImages: false,
            watchSlidesVisibility: true,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            pagination: {
              el: $paginationEl.get(),
              clickable: true,
              bulletClass: "carousel-indicators-bullet",
              bulletActiveClass: "active",
              renderBullet: function (index, className) {
                return '<li class="' + className + '"><span></span></li>';
              }
            }
          });
        });
      }
      break;
    default:
      if (on_off) {
        this.removeSwipes();
        $(".productlist-gallery-swiper-container").each(function () {
          var $swiperEl = $(this);
          var $parentEl = $swiperEl.parent();
          var $paginationEl = $parentEl.find('.productlist-gallery-swiper-element.carousel-indicators');
          var $navNextEl = $parentEl.find('.productlist-gallery-swiper-element.swiper-button-next');
          var $navPrevEl = $parentEl.find('.productlist-gallery-swiper-element.swiper-button-prev');

          new Swiper($swiperEl.get(), {
            watchOverflow: true,
            speed: 600,
            preloadImages: false,
            watchSlidesVisibility: true,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            pagination: {
              el: $paginationEl.get(),
              clickable: true,
              bulletClass: "carousel-indicators-bullet",
              bulletActiveClass: "active",
              renderBullet: function (index, className) {
                return '<li class="' + className + '"><span></span></li>';
              }
            },
            navigation: {
              nextEl: $navNextEl.get(),
              prevEl: $navPrevEl.get()
            }
          });
        });
      }
  }
};
